import {useQuery} from "@tanstack/react-query";
import {getNewGamesService} from "../../services/games/gamesList/newGames.service";
import {isVisibleGame} from "../../util/hiddenGames";

export const useGetNewGames = provider => {
  const {data, isPending} = useQuery({
    queryKey: ["newGames", provider],
    queryFn: () => getNewGamesService(provider),
    select: responseData => {
      const games = responseData?.data?.data || [];
      return {...responseData, data: {...responseData?.data, data: games.filter(isVisibleGame)}};
    },
  });
  return {
    data,
    isPending,
  };
};
